// eslint-disable-next-line
/* eslint-disable */
import Vue from 'vue'
import store from '@/store/index'
import router from '@/router/index'

const bc = new BroadcastChannel('tabs_broadcast')

bc.onmessage = ({ data }) => {
  const activeCall = store.state.widget.activeCall

  if (data === 'open') {
    bc.postMessage(`onCall-${activeCall ? '1' : '0'}`)
  }

  if (data === 'onCall-1' && !activeCall) {
    store.state.widget.isBusy = true
  } else if (data === 'callFinished') {
    store.state.widget.isBusy = false

    if (router.currentRoute.name === 'isBusy') {
      router.replace({ path: '/' })
    }
  }
}

class TabsManager {
  init = () => {
    bc.postMessage('open')
  }

  callStarted = () => {
    bc.postMessage('onCall-1')
  }

  callFinished = () => {
    bc.postMessage('callFinished')
  }
}

window.addEventListener('beforeunload', () => {
  bc.postMessage('close')
  bc.close()
})

Vue.prototype.$tabsManager = new TabsManager()
Vue.prototype.$tabsManager.init()
